// extracted by mini-css-extract-plugin
module.exports = {"button":"StatisticsFilters_button__1Nx9q","alert":"StatisticsFilters_alert__2k0JA","user":"StatisticsFilters_user__OyF-H","container":"StatisticsFilters_container__5pDq_"};